import Grid, { GridProps } from '@mui/material/Grid';

export const GridContainer = ({ children, ...props }: GridProps) => {
  return (
    <Grid container {...props}>
      {children}
    </Grid>
  );
};

type GridItemProps = Omit<GridProps, 'container'>;

export const GridItem = ({ children, ...props }: GridItemProps) => {
  return (
    <Grid item {...props}>
      {children}
    </Grid>
  );
};
